// extracted by mini-css-extract-plugin
export default {"select":"StatusSelect_select__L0naq"};